import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=3684f533&scoped=true"
import script from "./privacy.ts?vue&type=script&lang=ts&external"
export * from "./privacy.ts?vue&type=script&lang=ts&external"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=3684f533&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684f533",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3684f533')) {
      api.createRecord('3684f533', component.options)
    } else {
      api.reload('3684f533', component.options)
    }
    module.hot.accept("./Privacy.vue?vue&type=template&id=3684f533&scoped=true", function () {
      api.rerender('3684f533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/privacy/Privacy.vue"
export default component.exports